import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';


const StyledButton = styled(Button)`
    color: ${({ currentindex, itemlength }) => Boolean(currentindex === itemlength) ? 'gray' : '#fff'};
    &:disabled {
        color: gray;
        cursor: not-allowed;
    }
`

const Actions = ({ pageIndex, item, previousPage, nextPage }) => {

    return (
        <React.Fragment>
            <StyledButton
                disabled={pageIndex === 0}
                currentindex={pageIndex}
                itemlength={0}
                onClick={() => previousPage(pageIndex === 1 ? item[0] : item[pageIndex - 1])}
            >
                <ArrowBackIcon /> Previous
            </StyledButton>
            <StyledButton
                disabled={pageIndex === item.length - 1}
                currentindex={pageIndex}
                itemlength={item.length - 1}
                onClick={() => nextPage(item[pageIndex + 1])}
            >
                Next <ArrowForwardIcon />
            </StyledButton>
        </React.Fragment>
    )
};

Actions.propType = {
    pageIndex: PropTypes.number,
    item: PropTypes.arrayOf(PropTypes.any),
    previousPage: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
}
Actions.defaulProps = {
}
export default Actions;


// WEBPACK FOOTER //
// ./src/Components/Navbar/Actions.js